const MILESTONES = [25, 50, 75, 100] as const;
const DEBOUNCE_MS = 100;

type Push = (name: string, properties?: Record<string, unknown>) => void;

export function startScrollTracking(push: Push): () => void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  let maxMilestone = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;

  function check() {
    const el = document.documentElement;
    const scrollable = el.scrollHeight - el.clientHeight;
    if (scrollable <= 0) return;

    const pct = Math.min(100, Math.round((window.scrollY / scrollable) * 100));

    for (const milestone of MILESTONES) {
      if (pct >= milestone && maxMilestone < milestone) {
        maxMilestone = milestone;
        push('scroll', { scroll_pct: milestone });
      }
    }
  }

  function handler() {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(check, DEBOUNCE_MS);
  }

  window.addEventListener('scroll', handler, { passive: true });

  return () => {
    window.removeEventListener('scroll', handler);
    if (timer !== null) clearTimeout(timer);
    timer = null;
  };
}
